const imageManage = () => import("./views/imageManage.vue");

export default {
  // 图片管理
  path: "/imageManage",
  name: "imageManage",
  component: imageManage,
  meta: {
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/image/router.js